module.exports = __webpack_public_path__ + "static/img/abimg3.2669dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/abimg3.png
// module id = ZNpY
// module chunks = 1